import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";

const CheckBoxGroup = ({ title, data, setCheckBoxValue, row, onChange, values, disabled, error, sm = 6, xs = 12, isOptional }) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <React.Fragment>
            <FormControl variant="outlined" fullWidth>
                <Grid container>
                    {title && <FormLabel style={{ fontFamily: 'SophiaPro', fontWeight: 500, fontSize: 14, margin: 0, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{title} {isOptional ? <span className="optional-label">Optional</span> : null}</FormLabel>}
                    <Grid container>
                        <FormGroup row={row} sx={{ display: "flex", }}>
                            {
                                data && data.length > 0 && data.map((x, idx) =>
                                    <Grid
                                        item
                                        xs={xs}
                                        sm={sm}
                                        key={`radio-group-${idx}`}
                                        onMouseEnter={() => setHoveredIndex(idx)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                        sx={{
                                            backgroundColor: hoveredIndex === idx ? "#F5F5F5" : "transparent",
                                            transition: "background-color 0.3s ease",
                                            paddingLeft: "10px",
                                            paddingRight: "10px",
                                            borderRadius: "10px"
                                        }}
                                    >
                                        <FormControlLabel key={idx}
                                            sx={{ marginBottom: "0px" }}
                                            control={
                                                <Checkbox checked={x.value === -1
                                                    ? data.filter(d => d.value !== -1).every(d => values?.includes(d.value))
                                                    : values?.includes(x.value)
                                                } disabled={disabled}
                                                    key={idx}
                                                    error={error ? true : false}
                                                    sx={{
                                                        '&.Mui-checked': {
                                                            color: "#1D1B1B",
                                                        },
                                                        '& .MuiSvgIcon-root': {
                                                            fontSize: 18,
                                                            borderColor: "#E2E2E2"
                                                        },
                                                        color: '#1D1B1B'
                                                    }}
                                                    onChange={(event) => disabled ? "" : onChange && onChange(event, x)} value={x.name} />
                                            }
                                            label={<span style={{ fontFamily: 'SophiaPro', fontSize: 14 }}>{x.label}</span>}
                                        />
                                    </Grid>

                                )
                            }
                        </FormGroup>
                        {error ? <FormHelperText sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={16} width={16} />{error || ""}</FormHelperText> : null}
                    </Grid>

                </Grid>
            </FormControl>

        </React.Fragment >
    );
};

export default CheckBoxGroup;
